<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
    <!-- footer version -->
    <div class="ly-footer">
      <span>
        ©{{ year }}
        <a :href="lyodsUrl" target="_blank">{{ lyodsClientName }}</a>
        {{ $t("PUB.copyright") }}. V{{ lyodsVersion }}
      </span>
    </div>
  </section>
</template>

<script>
import watermark from "@/utils/waterMark";
export default {
  name: "AppMain",
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    },
  },
  data() {
    return {
      // 年份
      year: new Date().getFullYear(),
      // 是否开启水印
      waterMark: false,
      // 水印内容
      waterMarkMsg: "",
      height: "",
      lyodsVersion: localStorage.getItem("lyods-version"),
      lyodsUrl: this.$store.getters.userInfo.url,
      lyodsClientName: this.$store.getters.userInfo.clientName || this.$t("PUB.lyods"),
    };
  },
  methods: {
    // 开启水印
    getWaterMark() {
      this.waterMark = this.$store.state.user.waterMark;
      if (this.waterMark) {
        this.waterMarkMsg = this.$store.state.user.waterMarkMsg;
      } else {
        this.waterMarkMsg = "";
      }
      watermark.set(this.waterMarkMsg);
    },
    // 密码到期天数
    getHasDays() {
      let hasDays = Number(this.$store.getters.userInfo.hasDays);
      if(hasDays > 0){
        this.lyMsgInfo(this.$t('PUB.hasDays')+hasDays)
      }
    },
  },
  mounted() {
    this.getWaterMark();
    this.getHasDays();
  },
};
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
.test {
  display: block;
}
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/AppMain.vue